import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import SectionHeader from '../../components/SectionHeader';

function ServicePage({ title, slug, metaDesc, heroImg, eyebrow, intro, features, gallery, whyUs }) {
  return (
    <>
      <Helmet>
        <title>{title} | Wedoo Interiors Tumakuru</title>
        <meta name="description" content={metaDesc} />
        <meta name="keywords" content={`${title.toLowerCase()}, wedoo interiors, interior design tumakuru, ${slug.replace(/-/g,' ')} tumakuru`} />
      </Helmet>

      {/* Full-screen hero */}
      <div style={{ position:'relative', height:'70vh', minHeight:'520px', overflow:'hidden' }}>
        <div style={{ position:'absolute', inset:0, background:`url(${heroImg}) center/cover no-repeat` }} />
        <div className="hero-overlay" />
        {/* Decorative */}
        <div style={{ position:'absolute', bottom:'15%', right:'8%', width:'200px', height:'200px', border:'1px solid rgba(245,168,0,0.1)', borderRadius:'50%', animation:'spin 30s linear infinite', pointerEvents:'none' }} />
        <div className="container" style={{ position:'relative', zIndex:2, height:'100%', display:'flex', alignItems:'flex-end', paddingBottom:'4rem' }}>
          <div style={{ maxWidth:'700px', paddingTop:'6rem' }}>
            <span className="tag-label" style={{ marginBottom:'1rem', display:'flex', alignItems:'center', gap:'0.5rem' }}>{eyebrow}</span>
            <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(2.5rem,5vw,4rem)', fontWeight:600, color:'#f8f5ef', lineHeight:1.05, marginBottom:'1.25rem', letterSpacing:'-0.02em' }}>{title}</h1>
            <div className="gold-line" />
            <p style={{ color:'rgba(248,245,239,0.72)', fontSize:'0.95rem', lineHeight:'1.8', maxWidth:'560px' }}>{intro}</p>
          </div>
        </div>
      </div>

      {/* Features */}
      <section className="section-pad" style={{ background:'#0c0c0c' }}>
        <div className="container">
          <SectionHeader eyebrow="What We Offer" title={<>Service <em style={{color:'#F5A800',fontStyle:'italic'}}>Details</em></>} center />
          <div className="grid-3" style={{ gap:'2px', background:'rgba(245,168,0,0.06)' }}>
            {features.map(f => (
              <div key={f.title} style={{ background:'#0c0c0c', padding:'2.5rem 2rem', transition:'background 0.3s' }}
                onMouseEnter={e=>e.currentTarget.style.background='#141414'}
                onMouseLeave={e=>e.currentTarget.style.background='#0c0c0c'}>
                <div style={{ fontSize:'2rem', marginBottom:'1.1rem' }}>{f.icon}</div>
                <h3 style={{ fontFamily:'var(--font-display)', fontSize:'1.25rem', fontWeight:400, color:'#f8f5ef', marginBottom:'0.85rem', lineHeight:1.2 }}>{f.title}</h3>
                <p style={{ color:'#8a8278', fontSize:'0.82rem', lineHeight:'1.75' }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="section-pad" style={{ background:'#141414' }}>
        <div className="container">
          <SectionHeader eyebrow="Our Work" title={<>Project <em style={{color:'#F5A800',fontStyle:'italic'}}>Gallery</em></>} center />
          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'4px' }} className="gal-grid">
            {gallery.map((img,i) => (
              <div key={i} className="port-item" style={{ height:'280px' }}>
                <img src={img} alt={`${title} ${i+1}`} />
              </div>
            ))}
          </div>
        </div>
        <style>{`@media(max-width:640px){.gal-grid{grid-template-columns:1fr!important}}`}</style>
      </section>

      {/* Why Us */}
      {whyUs && (
        <section className="section-pad" style={{ background:'#0c0c0c' }}>
          <div className="container">
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'5rem', alignItems:'center' }} className="why-grid">
              <div>
                <SectionHeader eyebrow="Why Wedoo" title={<>Why Choose <em style={{color:'#F5A800',fontStyle:'italic'}}>Us</em></>} subtitle={whyUs.subtitle} />
                <div style={{ display:'flex', flexDirection:'column', gap:'1rem', marginBottom:'2.5rem' }}>
                  {whyUs.points.map(p => (
                    <div key={p} style={{ display:'flex', gap:'0.85rem', alignItems:'center', color:'#ede8de', fontSize:'0.85rem', padding:'0.75rem 0', borderBottom:'1px solid rgba(255,255,255,0.04)' }}>
                      <span style={{ color:'#F5A800', fontSize:'0.7rem' }}>✦</span>{p}
                    </div>
                  ))}
                </div>
                <Link to="/get-free-quote" className="btn btn-gold">Get Free Quote →</Link>
              </div>
              <img src={whyUs.img} alt={title} style={{ width:'100%', height:'460px', objectFit:'cover' }} />
            </div>
          </div>
          <style>{`@media(max-width:768px){.why-grid{grid-template-columns:1fr!important;gap:2.5rem!important}}`}</style>
        </section>
      )}

      {/* CTA */}
      <section style={{ padding:'6rem 0', textAlign:'center', background:'#141414', borderTop:'1px solid rgba(245,168,0,0.1)' }}>
        <div className="container">
          <span className="tag-label" style={{ justifyContent:'center', display:'flex', marginBottom:'1.5rem' }}>Get Started</span>
          <h2 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(1.8rem,4vw,2.8rem)', fontWeight:600, color:'#f8f5ef', marginBottom:'1.5rem' }}>
            Ready for Your Dream <em style={{ color:'#F5A800' }}>{title.split(' ')[0]}?</em>
          </h2>
          <p style={{ color:'#8a8278', fontSize:'0.88rem', maxWidth:'440px', margin:'0 auto 2.5rem', lineHeight:'1.8' }}>Book a free consultation and get a customised quote within 24 hours.</p>
          <div style={{ display:'flex', gap:'1rem', justifyContent:'center', flexWrap:'wrap' }}>
            <Link to="/get-free-quote" className="btn btn-gold">Book Free Consultation</Link>
            <Link to="/portfolio" className="btn btn-outline">View Portfolio</Link>
          </div>
        </div>
      </section>
    </>
  );
}

export function CompleteModular() {
  return <ServicePage title="Complete Modular Works" slug="complete-modular-site-work" eyebrow="Modular Works" metaDesc="Complete modular and site work by Wedoo Interiors in Tumakuru. Modular kitchens, wardrobes, storage units and complete modular interior execution."
    heroImg="https://interiosplash.com/wp-content/uploads/2024/09/1.A-spacious-living-room-Interior-Design-with-sofas-in-Bangalore-by-Interiosplash-Interior-Design-Company.webp"
    intro="Precision-crafted modular solutions built in controlled factory environments, delivered and installed at your site — from demolition to the final handover with a 5-year warranty."
    features={[
      
      { icon:'🗄️', title:'Modular Production', desc:'Factory-engineered modular units for kitchens, wardrobes, and storage — built to last.' },
      { icon:'🏠', title:'Floor & Tile Work', desc:'Demolition of existing flooring and installation of premium tiles with perfect finish.' },
      
      { icon:'⚡', title:'Electrical Works', desc:'New boards, TV and telephone points, light Shifting, fan Shifting.' },
      { icon:'🚿', title:'Plumbing', desc:'Complete plumbing solutions for kitchens and bathrooms.' },
    ]}
    gallery={[
      'https://images.unsplash.com/photo-1664711942326-2c3351e215e6?q=80&w=2017&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      'https://images.unsplash.com/photo-1571624436279-b272aff752b5?w=800&q=85',
      'https://interiosplash.com/wp-content/uploads/2024/09/1.A-spacious-living-room-Interior-Design-with-sofas-in-Bangalore-by-Interiosplash-Interior-Design-Company.webp',
    ]}
    whyUs={{ subtitle:'We manage every aspect of the project so you don\'t have to juggle contractors.', img:'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=700&q=85', points:['Single-point accountability — one team, one warranty','Factory precision + site expertise','Transparent timelines with daily updates','5-year warranty on all modular work'] }}
  />;
}

export function InteriorDesign() {
  return <ServicePage title="Interior Design" slug="interior-design" eyebrow="Design & Aesthetics" metaDesc="Premium interior design services by Wedoo Interiors in Tumakuru. 3D visualization, space planning, furniture curation and complete styling."
    heroImg="https://images.unsplash.com/photo-1618219908412-a29a1bb7b86e?w=1600&q=85"
    intro="Bespoke interiors that fuse aesthetic vision with functional intelligence — creating spaces that inspire, comfort, and authentically reflect who you are."
    features={[
      { icon:'📐', title:'Space Planning', desc:'Intelligent layouts that maximize every square foot of your home.' },
      { icon:'🎨', title:'3D Visualization', desc:'Photorealistic renders so you see your transformed space before work begins.' },
      { icon:'🛋️', title:'Furniture Curation', desc:'Handpicked furniture and accessories perfectly complementing your design story.' },
      { icon:'🎭', title:'Material Selection', desc:'Expert guidance on textures, finishes and materials that stand the test of time.' },
      { icon:'💡', title:'Concept Design', desc:'Mood boards and concept presentations tailored precisely to your lifestyle.' },
      { icon:'🏡', title:'Complete Styling', desc:'From architectural elements to the final cushion — every detail curated.' },
    ]}
    gallery={[
      'https://images.unsplash.com/photo-1600210492493-0946911123ea?w=800&q=85',
      'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&q=85',
      'https://images.unsplash.com/photo-1618219908412-a29a1bb7b86e?w=800&q=85',
    ]}
    whyUs={{ subtitle:'Our designers blend global aesthetics with deep understanding of the Indian home.', img:'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=700&q=85', points:['In-house designers with 5+ years experience','Full 3D design before any execution','Material and furniture sourcing support','Dedicated project manager from day one'] }}
  />;
}

export function HomeLighting() {
  return <ServicePage title="Home Lighting Design" slug="home-lighting" eyebrow="Lighting & Ambiance" metaDesc="Expert home lighting design by Wedoo Interiors in Tumakuru. Cove lighting, chandeliers, task lighting and smart controls."
    heroImg="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1600&q=85"
    intro="Curated lighting schemes that define ambiance, elevate aesthetics, and enhance everyday life — from dramatic chandeliers to intimate cove lighting and intelligent smart controls."
    features={[
      { icon:'🕯️', title:'Ambient Lighting', desc:'Soft, layered illumination that creates warmth and comfort throughout.' },
      { icon:'💡', title:'Cove Lighting', desc:'Elegant LED cove and tray ceiling lighting for a contemporary glow.' },
      { icon:'🔦', title:'Task Lighting', desc:'Functional, precise lighting for kitchens, studies, and workspaces.' },
      { icon:'✨', title:'Accent Lighting', desc:'Highlight artwork, architecture, and statement decor with precision.' },
      { icon:'🔮', title:'Smart Controls', desc:'App and voice-controlled lighting systems for the modern home.' },
      { icon:'🪔', title:'Statement Fixtures', desc:'Designer chandeliers and pendants that become focal points in any room.' },
    ]}
    gallery={[
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=85',
      'https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=85',
      'https://images.unsplash.com/photo-1524484485831-a92ffc0de03f?w=800&q=85',
    ]}
    whyUs={{ subtitle:'Great lighting transforms even modest spaces into extraordinary ones.', img:'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=700&q=85', points:['Full lighting layout design included','LED-first for energy efficiency and longevity','Smart home integration support','Site visit before and after installation'] }}
  />;
}

export function ModularKitchen() {
  return <ServicePage title="Modular Kitchen" slug="modular-kitchen" eyebrow="Kitchen Design" metaDesc="Custom modular kitchens by Wedoo Interiors in Tumakuru. Smart storage, premium countertops, Hettich hardware and innovative accessories."
    heroImg="https://images.unsplash.com/photo-1556909048-f4f37e18c11a?w=1600&q=85"
    intro="Smart, space-maximising kitchens engineered for modern Indian living — premium countertops, innovative storage, and hardware from the world's best brands."
    features={[
      { icon:'🪨', title:'Countertops', desc:'Granite, quartz, and marble countertops crafted for beauty and decades of durability.' },
      { icon:'🎨', title:'Custom Shutters', desc:'Lacquered, acrylic, and membrane finishes in 200+ colours and textures.' },
      { icon:'📦', title:'Smart Storage', desc:'Magic corners, pull-outs, organizers, and pantry solutions that maximize space.' },
      { icon:'🔩', title:'Premium Hardware', desc:'Soft-close hinges and channels from Hettich, Blum, and Hafele.' },
      { icon:'🧲', title:'Designer Backsplashes', desc:'Designer tiles, glass, and mosaic backsplashes that elevate the kitchen aesthetic.' },
      { icon:'🍳', title:'Appliance Garage', desc:'Hidden compartments for appliances keeping your counters beautifully clutter-free.' },
    ]}
    gallery={[
      'https://images.unsplash.com/photo-1556909048-f4f37e18c11a?w=800&q=85',
      'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=800&q=85',
      'https://images.unsplash.com/photo-1664711942326-2c3351e215e6?q=80&w=2017&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    ]}
    whyUs={{ subtitle:'We believe the kitchen is the heart of the home — and we treat it accordingly.', img:'https://images.unsplash.com/photo-1556909048-f4f37e18c11a?w=700&q=85', points:['Factory production with site precision','Branded hardware — Hettich, Blum, Hafele','Vastu-compliant layouts available','5-year warranty on all kitchen work'] }}
  />;
}

export function FalseCeiling() {
  return <ServicePage title="False Ceiling & Painting" slug="false-ceiling-painting" eyebrow="Ceilings & Finishes" metaDesc="False ceiling design and premium painting services by Wedoo Interiors in Tumakuru. Gypsum, POP, cove lighting and texture paints."
    heroImg="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1600&q=85"
    intro="Creative ceiling designs and premium wall finishes that completely transform the character and feel of every room — from subtle elegance to dramatic statement."
    features={[
      { icon:'📐', title:'Gypsum Ceilings', desc:'Smooth gypsum board ceilings with precise jointing and perfect finish every time.' },
      { icon:'💡', title:'Cove with LED', desc:'Integrated LED cove lighting in ceilings for warm, dramatic ambient glow.' },
      { icon:'🎨', title:'POP Work', desc:'Plaster of Paris ceilings with intricate mouldings and 3D design elements.' },
      { icon:'🖌️', title:'Premium Paint', desc:'Asian Paints Royale and premium emulsions for walls and ceilings.' },
      { icon:'🌊', title:'Texture Finishes', desc:'Venetian plaster, brick effect, suede, and dozens of designer wall textures.' },
      { icon:'🏛️', title:'Vertical Panels', desc:'Contemporary vertical gypsum panel feature walls with integrated lighting.' },
    ]}
    gallery={[
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=85',
      'https://images.unsplash.com/photo-1618219908412-a29a1bb7b86e?w=800&q=85',
      'https://images.unsplash.com/photo-1505691938895-1758d7feb511?w=800&q=85',
    ]}
    whyUs={{ subtitle:'The ceiling is the fifth wall — we give it the attention it deserves.', img:'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=700&q=85', points:['Integrated lighting design included','Dust-free process — minimal disruption','Premium paint brands only','3-year warranty on all ceiling work'] }}
  />;
}

export function AluminiumGlass() {
  return <ServicePage title="Aluminium & Glass Works" slug="aluminium-glass-works" eyebrow="Glass & Aluminium" metaDesc="Aluminium & glass works by Wedoo Interiors in Tumakuru. Shower partitions, glass railings, aluminium doors and spider glass fittings."
    heroImg="https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=1600&q=85"
    intro="Contemporary glass and aluminium solutions that bring light, openness, and architectural elegance to modern homes — precision fabricated and expertly installed."
    features={[
      { icon:'🚿', title:'Shower Partitions', desc:'Frameless and semi-frameless glass shower enclosures with premium branded fittings.' },
      { icon:'🪞', title:'Glass Railings', desc:'Toughened glass railings for staircases, balconies, and mezzanines.' },
      { icon:'🚪', title:'Aluminium Doors', desc:'Thermally-broken aluminium doors and windows in modern profiles and powder-coat finishes.' },
      { icon:'🪟', title:'Double-Glazed Windows', desc:'Sound-insulating, thermally efficient double-glazed windows for complete comfort.' },
      { icon:'🔮', title:'Glass Partitions', desc:'Frameless glass interior walls for open-plan spaces with privacy when needed.' },
      { icon:'🕷️', title:'Spider Fittings', desc:'Structural glass facades and canopies with precision stainless steel spider fittings.' },
    ]}
    gallery={[
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&q=85',
      'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&q=85',
      'https://images.unsplash.com/photo-1556909048-f4f37e18c11a?w=800&q=85',
    ]}
    whyUs={{ subtitle:'We use only toughened and tempered safety glass with certified fittings.', img:'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=700&q=85', points:['IS-certified toughened safety glass only','Precision factory fabrication','Professional site installation team','2-year warranty on all glass work'] }}
  />;
}
